/**
 * Takes n amount of refs and combines them to ones so a single element can have multiple refs.
 * @param refs
 * @return {function(...[*]=)}
 */
export const combineRefs = (...refs) => (el) => {
    refs.forEach((ref) => {
        if (!ref) {
            return;
        }
        if (typeof ref === "function") {
            ref(el);
        }
        else {
            // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065#issuecomment-547327595
            ref.current = el;
        }
    });
};
